export interface SelectData {
    title: string;
    isSingleSelect?: boolean;
    isDisabled?: boolean;
    selectedItems?: SelectItem[];
    listItems: SelectItem[];
}

export interface SelectItem {
    id: number | string;
    name?: string;
    isChecked?: boolean;
    isDisabled?: boolean;
    data?: any;
}

export interface ExcludeFilterItems {
    protocol?: boolean;
    project?: boolean;
    region?: boolean;
    country?: boolean;
    investigator?: boolean;
}

export interface FilterLabels {
    title: string;
    newText: string;
    editText: string;
    deleteText: string;
    infoMsg: string;
    menuToolTip: string;
    groupName: string;
}

export interface SelectedItemList {
    filters: FilterItems;
    reportType: ReportType;
    protocolCode?: string[];
    studyGroupName?: string[];
    reoccurencePattern?: string;
    scheduleRunTime?: string;
    params?: {};
    scheduleFilterContent?: { daily?: string, weekly?: string, monthly?: string };
    reportAction?: number;
    dateRange?: DateRangeOption;
    isGeneratedNotSavedReport: boolean;
}

export interface FilterItems {
    studyGroups: SelectItem[];
    protocol: SelectItem[];
    project: SelectItem[];
    country: SelectItem[];
    investigator: SelectItem[];
    region: SelectItem[];
}

export enum ReportType {
    SpecimenManagementInventoryReport = 1,
    SampleTrackingReport = 2
}

export enum DynamicReportView {
    SMInventoryReport = 'in-inventory-report',
    SampleTrackingReport = 'sample-tracking-report',
}

export interface DailyData {
    days?: number;
    isEveryWeekDay?: boolean;
}

export interface WeeklyData {
    recureEvery: number;
    weeks: string;
}

export interface MonthlyData {
    isDay?: boolean;
    dayNumber?: number;
    dayMonth?: number;

    weekDayNumber?: string;
    weekDay?: number;
    weekMonths?: number;
}

export interface DateRangeFilter {
    key: number;
    value: string;
    label: string;
    isChecked?: boolean;
}

export enum DateRangeTypes {
    dateRange = 'dateRange',
    weekly = '7',
    monthly = '30',
    twoMonths = '60',
    quarterly = '90'
}

export interface DateRangeOption {
    dateField: string;
    fromDate?: string;
    toDate?: string;
    daysBack?: number;
}

export interface DateRangeReportOption {
    dateField: string;
    fromDate?: string;
    toDate?: string;
}